import React from 'react';
import './Dashboard.css';

const AssociadoDashboard = () => {
  return (
    <div className="dashboard-container">
      <div className="dashboard-header">
        <h1>Dashboard Associado</h1>
        <div className="date-filter">
          <select>
            <option>Últimos 7 dias</option>
            <option>Últimos 30 dias</option>
            <option>Este mês</option>
            <option>Este ano</option>
          </select>
        </div>
      </div>
      
      <div className="stats-grid">
        <div className="stat-card">
          <h3>Meus Processos</h3>
          <div className="stat-value">24</div>
          <div className="stat-trend up">+3 desde a semana passada</div>
        </div>
        
        <div className="stat-card">
          <h3>Aguardando Ação</h3>
          <div className="stat-value">8</div>
          <div className="stat-trend down">-2 desde a semana passada</div>
        </div>
        
        <div className="stat-card">
          <h3>Concluídos</h3>
          <div className="stat-value">5</div>
          <div className="stat-trend up">+2 desde a semana passada</div>
        </div>
        
        <div className="stat-card">
          <h3>Reuniões Agendadas</h3>
          <div className="stat-value">3</div>
          <div className="stat-trend flat">Sem alteração</div>
        </div>
      </div>
      
      <div className="dashboard-card">
        <div className="card-header">
          <h3>Prazos Próximos</h3>
        </div>
        <table className="data-table">
          <thead>
            <tr>
              <th>Processo</th>
              <th>Cliente</th>
              <th>Tipo</th>
              <th>Prazo</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>PROC-2025-112</td>
              <td>João Oliveira</td>
              <td>Recurso Administrativo</td>
              <td>12/05/2025</td>
              <td><span className="status-badge urgent">2 dias</span></td>
            </tr>
            <tr>
              <td>PROC-2025-097</td>
              <td>Empresa XYZ</td>
              <td>Defesa Fiscal</td>
              <td>15/05/2025</td>
              <td><span className="status-badge warning">5 dias</span></td>
            </tr>
            <tr>
              <td>PROC-2025-118</td>
              <td>Marcelo Santos</td>
              <td>Consultoria Tributária</td>
              <td>20/05/2025</td>
              <td><span className="status-badge normal">10 dias</span></td>
            </tr>
          </tbody>
        </table>
      </div>
      
      <div className="dashboard-row">
        <div className="dashboard-column">
          <div className="dashboard-card">
            <div className="card-header">
              <h3>Atividades Recentes</h3>
            </div>
            <div className="activity-list">
              <div className="activity-item">
                <div className="activity-icon document">📄</div>
                <div className="activity-content">
                  <p><strong>Documento Enviado</strong></p>
                  <p>Petição inicial para o processo PROC-2025-112</p>
                  <p className="activity-time">Hoje, 11:32</p>
                </div>
              </div>
              
              <div className="activity-item">
                <div className="activity-icon meeting">📅</div>
                <div className="activity-content">
                  <p><strong>Reunião Realizada</strong></p>
                  <p>Consultoria com cliente Empresa XYZ</p>
                  <p className="activity-time">Ontem, 15:45</p>
                </div>
              </div>
              
              <div className="activity-item">
                <div className="activity-icon update">🔄</div>
                <div className="activity-content">
                  <p><strong>Status Atualizado</strong></p>
                  <p>Processo PROC-2025-097 marcado como "Em andamento"</p>
                  <p className="activity-time">09/05/2025, 09:15</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        <div className="dashboard-column">
          <div className="dashboard-card">
            <div className="card-header">
              <h3>Próximas Reuniões</h3>
            </div>
            <div className="meetings-list">
              <div className="meeting-item">
                <div className="meeting-time">
                  <p className="day">12</p>
                  <p className="month">MAI</p>
                </div>
                <div className="meeting-details">
                  <p className="meeting-title">Reunião com João Oliveira</p>
                  <p className="meeting-info">14:00 - 15:00 | Sala de Reuniões 2</p>
                </div>
              </div>
              
              <div className="meeting-item">
                <div className="meeting-time">
                  <p className="day">14</p>
                  <p className="month">MAI</p>
                </div>
                <div className="meeting-details">
                  <p className="meeting-title">Consultoria - Empresa XYZ</p>
                  <p className="meeting-info">10:30 - 12:00 | Videoconferência</p>
                </div>
              </div>
              
              <div className="meeting-item">
                <div className="meeting-time">
                  <p className="day">17</p>
                  <p className="month">MAI</p>
                </div>
                <div className="meeting-details">
                  <p className="meeting-title">Reunião de Equipe</p>
                  <p className="meeting-info">09:00 - 10:30 | Sala de Conferências</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AssociadoDashboard;